import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Layout, Menu, Dropdown, Avatar, Typography, Space, Breadcrumb, Drawer, Button } from 'antd';
import { ReadOutlined, DashboardOutlined, BookOutlined, BankOutlined, ShopOutlined, HomeOutlined, FileSearchOutlined, TeamOutlined, SafetyCertificateOutlined, UserOutlined, LogoutOutlined, DownOutlined, BarsOutlined, ContainerOutlined, CalendarOutlined, AppstoreOutlined, DollarOutlined, FieldNumberOutlined, GoldOutlined, PieChartOutlined, ScheduleOutlined, ShoppingCartOutlined, ShoppingOutlined, StockOutlined, TagsOutlined, MenuOutlined, } from '@ant-design/icons';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';
import { api } from '@/lib/api';
import { useIsTablet, useIsMobile } from '@/lib/breakpoints';
const { Header, Sider, Content } = Layout;
const navConfig = [
    { key: '/panduan', label: 'Panduan Pengguna', icon: _jsx(ReadOutlined, {}) },
    { key: '/dashboard', label: 'Dashboard', icon: _jsx(DashboardOutlined, {}), perm: 'dashboard:view' },
    {
        key: 'accounting',
        label: 'Akuntansi',
        icon: _jsx(BookOutlined, {}),
        children: [
            { key: '/accounting/journals', label: 'Jurnal', icon: _jsx(BarsOutlined, {}), perm: 'journal:view' },
            { key: '/accounting/coa', label: 'Bagan Akun', icon: _jsx(ContainerOutlined, {}), perm: 'coa:view' },
            { key: '/accounting/funds', label: 'Dana', icon: _jsx(BankOutlined, {}), perm: 'fund:view' },
            { key: '/accounting/periods', label: 'Periode', icon: _jsx(CalendarOutlined, {}), perm: 'period:view' },
        ],
    },
    {
        key: 'reports',
        label: 'Laporan',
        icon: _jsx(FileSearchOutlined, {}),
        children: [
            { key: '/reports/trial-balance', label: 'Neraca Saldo', icon: _jsx(FileSearchOutlined, {}), perm: 'report.trial_balance:view' },
            { key: '/reports/balance-sheet', label: 'Posisi Keuangan', icon: _jsx(FileSearchOutlined, {}), perm: 'report.balance_sheet:view' },
            { key: '/reports/activity', label: 'Aktivitas', icon: _jsx(FileSearchOutlined, {}), perm: 'report.activity:view' },
            { key: '/reports/cash-flow', label: 'Arus Kas', icon: _jsx(FileSearchOutlined, {}), perm: 'report.cashflow:view' },
            { key: '/reports/aging-makam', label: 'Aging Makam', icon: _jsx(FileSearchOutlined, {}), perm: 'report.aging_makam:view' },
            { key: '/reports/aging-abu', label: 'Aging Rumah Abu', icon: _jsx(FileSearchOutlined, {}), perm: 'report.aging_abu:view' },
            { key: '/reports/stock-valuation', label: 'Valuasi Stok', icon: _jsx(FileSearchOutlined, {}), perm: 'report.stock_valuation:view' },
            { key: '/reports/sales-summary', label: 'Ringkasan Penjualan', icon: _jsx(FileSearchOutlined, {}), perm: 'report.sales_summary:view' },
        ],
    },
    {
        key: 'makam',
        label: 'Makam',
        icon: _jsx(HomeOutlined, {}),
        children: [
            { key: '/makam/plots', label: 'Petak', icon: _jsx(AppstoreOutlined, {}), perm: 'makam.plot:view' },
            { key: '/makam/blocks', label: 'Blok', icon: _jsx(FieldNumberOutlined, {}), perm: 'makam.plot:view' },
            { key: '/makam/contracts', label: 'Kontrak', icon: _jsx(ScheduleOutlined, {}), perm: 'makam.contract:view' },
            { key: '/makam/maintenance', label: 'Iuran Perawatan', icon: _jsx(TagsOutlined, {}), perm: 'makam.contract:view' },
        ],
    },
    {
        key: 'abu',
        label: 'Rumah Abu',
        icon: _jsx(BankOutlined, {}),
        children: [
            { key: '/abu/niches', label: 'Lokus', icon: _jsx(AppstoreOutlined, {}), perm: 'abu.niche:view' },
            { key: '/abu/contracts', label: 'Kontrak', icon: _jsx(ScheduleOutlined, {}), perm: 'abu.contract:view' },
            { key: '/abu/recognition', label: 'Pengakuan Bulanan', icon: _jsx(PieChartOutlined, {}), perm: 'abu.contract:view' },
        ],
    },
    {
        key: 'toko',
        label: 'Toko',
        icon: _jsx(ShopOutlined, {}),
        children: [
            { key: '/toko/pos', label: 'Kasir POS', icon: _jsx(ShoppingCartOutlined, {}), perm: 'pos:sell' },
            { key: '/toko/products', label: 'Produk', icon: _jsx(GoldOutlined, {}), perm: 'product:view' },
            { key: '/toko/categories', label: 'Kategori', icon: _jsx(TagsOutlined, {}), perm: 'product:view' },
            { key: '/toko/movements', label: 'Pergerakan Stok', icon: _jsx(StockOutlined, {}), perm: 'stock:view' },
            { key: '/toko/purchase', label: 'Input Pembelian', icon: _jsx(ShoppingOutlined, {}), perm: 'stock:adjust' },
            { key: '/toko/valuation', label: 'Valuasi Stok', icon: _jsx(DollarOutlined, {}), perm: 'report.stock_valuation:view' },
        ],
    },
    { key: '/users', label: 'Pengguna', icon: _jsx(TeamOutlined, {}), perm: 'user:view' },
    { key: '/roles', label: 'Role & Permission', icon: _jsx(SafetyCertificateOutlined, {}), perm: 'role:view' },
    { key: '/audit', label: 'Audit Log', icon: _jsx(FileSearchOutlined, {}), perm: 'audit:view' },
];
function filterNav(items, has) {
    return items
        .map((it) => {
        if (it.children) {
            const kids = filterNav(it.children, has);
            return kids && kids.length > 0
                ? { key: it.key, icon: it.icon, label: it.label, children: kids }
                : null;
        }
        if (it.perm && !has(it.perm))
            return null;
        return {
            key: it.key,
            icon: it.icon,
            label: _jsx(Link, { to: it.key, children: it.label }),
        };
    })
        .filter(Boolean);
}
export function AppLayout() {
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();
    const [collapsed, setCollapsed] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const user = useAuthStore((s) => s.user);
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const logout = useAuthStore((s) => s.logout);
    // Auto-close drawer on route change (mobile)
    useEffect(() => {
        setDrawerOpen(false);
    }, [location.pathname]);
    const menuItems = useMemo(() => filterNav(navConfig, hasPerm), [hasPerm]);
    const openKeys = useMemo(() => {
        return navConfig
            .filter((n) => n.children?.some((c) => location.pathname.startsWith(c.key)))
            .map((n) => n.key);
    }, [location.pathname]);
    const selectedKeys = useMemo(() => [location.pathname], [location.pathname]);
    const userMenu = [
        { key: 'profile', label: user?.full_name ?? '-', icon: _jsx(UserOutlined, {}), disabled: true },
        { type: 'divider' },
        {
            key: 'logout',
            label: 'Keluar',
            icon: _jsx(LogoutOutlined, {}),
            danger: true,
            onClick: async () => {
                try {
                    await api.post('/auth/logout', {
                        refresh_token: useAuthStore.getState().refreshToken,
                    });
                }
                catch {
                    /* ignore */
                }
                logout();
                navigate('/login');
            },
        },
    ];
    const crumbs = location.pathname
        .split('/')
        .filter(Boolean)
        .map((seg, i, arr) => ({
        title: _jsx("span", { style: { textTransform: 'capitalize' }, children: seg.replace('-', ' ') }),
        href: '/' + arr.slice(0, i + 1).join('/'),
    }));
    const brandBlock = (_jsx("div", { style: { padding: 16, textAlign: 'center' }, children: _jsxs("div", { className: "hbt-brand", children: [_jsx("span", { className: "dot" }), !collapsed && _jsx("span", { children: "HBT Pekanbaru" })] }) }));
    const menuBlock = (_jsx(Menu, { theme: "dark", mode: "inline", items: menuItems, selectedKeys: selectedKeys, defaultOpenKeys: openKeys, style: { borderInlineEnd: 'none' } }));
    return (_jsxs(Layout, { style: { minHeight: '100vh' }, children: [!isTablet && (_jsxs(Sider, { theme: "dark", collapsible: true, collapsed: collapsed, onCollapse: setCollapsed, width: 220, children: [brandBlock, menuBlock] })), isTablet && (_jsx(Drawer, { placement: "left", open: drawerOpen, onClose: () => setDrawerOpen(false), width: 280, bodyStyle: { padding: 0, background: '#1F1B1A' }, headerStyle: { display: 'none' }, maskClosable: true, children: _jsxs("div", { style: { background: '#1F1B1A', minHeight: '100%', paddingBottom: 24 }, children: [_jsx("div", { style: {
                                padding: '16px 20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderBottom: '1px solid rgba(255,255,255,0.06)',
                            }, children: _jsxs("div", { className: "hbt-brand", style: { margin: 0 }, children: [_jsx("span", { className: "dot" }), _jsx("span", { children: "HBT Pekanbaru" })] }) }), menuBlock] }) })), _jsxs(Layout, { children: [_jsxs(Header, { className: "hbt-shell-header", children: [_jsxs(Space, { size: 12, style: { minWidth: 0, flex: 1 }, children: [isTablet && (_jsx(Button, { type: "text", icon: _jsx(MenuOutlined, { style: { color: '#FEF3C7', fontSize: 18 } }), onClick: () => setDrawerOpen(true), "aria-label": "Buka menu", style: { height: 40, width: 40, padding: 0 } })), isMobile ? (_jsx(Typography.Text, { style: {
                                            color: '#FEF3C7',
                                            fontWeight: 600,
                                            letterSpacing: '0.02em',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            minWidth: 0,
                                        }, children: crumbs.length > 0 ? crumbs[crumbs.length - 1].title : 'HBT Pekanbaru' })) : (_jsx(Breadcrumb, { items: [{ title: 'Beranda', href: '/' }, ...crumbs], style: { color: '#FEF3C7' } }))] }), _jsx(Dropdown, { menu: { items: userMenu }, placement: "bottomRight", trigger: ['click'], children: _jsxs(Space, { style: {
                                        cursor: 'pointer',
                                        color: '#FEF3C7',
                                        minHeight: 40,
                                        padding: isMobile ? '0 4px' : undefined,
                                    }, children: [_jsx(Avatar, { size: isMobile ? 32 : 'small', style: { background: '#FCA311', color: '#1F1B1A' }, children: user?.username?.[0]?.toUpperCase() ?? '?' }), !isMobile && (_jsxs(_Fragment, { children: [_jsx(Typography.Text, { style: { color: '#FEF3C7' }, children: user?.username }), _jsx(DownOutlined, { style: { fontSize: 10 } })] }))] }) })] }), _jsx(Content, { className: "hbt-content", children: _jsx(Outlet, {}) })] })] }));
}
